import { render, staticRenderFns } from "./YourObsoleteBadgesBanner.vue?vue&type=template&id=7c1592e4&scoped=true"
import script from "./YourObsoleteBadgesBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./YourObsoleteBadgesBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourObsoleteBadgesBanner.vue?vue&type=style&index=0&id=7c1592e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1592e4",
  null
  
)

export default component.exports